import React, { useState } from 'react';

import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardHeader, Collapse } from 'reactstrap';
import styled from 'styled-components';
import { prop } from 'styled-tools';

import RichTextField from 'components/RichTextField/RichTextField';

const AccordionHeader = styled(CardHeader)`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-family: ${prop('theme.fonts.default')};
  font-size: 1.25rem;
  font-weight: 700;
  justify-content: space-between;
  text-transform: uppercase;
`;

const AccordionBody = styled.div`
  padding: 1.25rem;

  &&& {
    p {
      font-size: 0.875rem;

      @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        font-size: 1.125rem;
      }
    }
  }
`;

function TextAccordion({ body, header }: { body: string; header: string }) {
  const [toggleOpen, setToggleOpen] = useState(false);

  return (
    <Card>
      {header && (
        <AccordionHeader onClick={() => setToggleOpen(!toggleOpen)}>
          {header}
          <FontAwesomeIcon color='#e02529' icon={toggleOpen ? faMinus : faPlus} aria-label='plus' />
        </AccordionHeader>
      )}
      <Collapse isOpen={toggleOpen}>
        {body && (
          <AccordionBody>
            <RichTextField richText={body} />
          </AccordionBody>
        )}
      </Collapse>
    </Card>
  );
}

export default TextAccordion;
